import { z } from 'zod';
import { counter } from './counts.js';
/**
 * One page of a listing, over the wire.
 *
 * Every paged screen in the product sends the same four fields, and one
 * component on the browser side renders all of them. Written per listing they
 * were four copies of the same arithmetic, which is four chances for one screen
 * to send `total` meaning "rows on this page" and page into emptiness.
 *
 * `rows` is the key everywhere, whatever the rows are. A listing that called
 * them `contacts` would need its own component, which is the cost of the nicer
 * name.
 */
export function pageOf(row) {
    return z.object({
        rows: z.array(row),
        /** Everything matching, not everything on this page. The pager needs both. */
        total: counter,
        page: z.number().int().min(1),
        pageSize: z.number().int().min(1),
    });
}
//# sourceMappingURL=paging.js.map